import Vue from "vue";

Vue.component("hs-product-filter", {
    props: ["label", "placeholder", "ids", "showHelpIcon", "helpIconTitle", "showDisclaimerIcon", "disclaimerTooltip"],
    data() {
        return {
            names: "",
            hsVersionId: 'HS7',
            options: [],
            showSelector: false,
            language: window.currentOfficialLanguageInt
        };
    },
    computed: {
        computedValue: {
            get() {
                const text = this.ids;
                if (!text) return [];
                return this.ids;
            },
            set(value) {
                this.getTextValue(value, this.options)
            }
        }
    },
    methods: {
        onFocusOut: function () {
            this.showSelector = false;
        },
        getTextValue: function (ids, options) {
            let returnValue = '';
            if (ids && ids.length > 0) {
                returnValue = "";
                ids.forEach(function (id) {
                    const option = options.find(function (item) {
                        return item.id === id;
                    });
                    if (option) returnValue += `${option.code} - ${option.description}; `;
                });
                returnValue = returnValue ? returnValue.substr(0, returnValue.length - 2) : "";
            }
            this.names = returnValue;
        },
        triggerSelector: function () {
            this.showSelector = !this.showSelector;

            if (this.showSelector) {
                setTimeout(() => {
                    let container = document.getElementById('hs-tree-select-container');
                    let input = container.querySelector('input.vue-treeselect__input');
                    input.focus();
                }, 200);
            }
        },
        onDataChange: function (value) {
            this.getTextValue(value, this.options)
            this.$emit('on-data-change', value)
        },
        getLatestHSVersion: function () {
            this.$services.hsVersions.getLatestHSVersion()
                .then((data) => {
                    this.hsVersionId = data;
                    this.getHSProductsForTreeSelect(data);
                });
        },
        getHSProductsForTreeSelect: function (hsVersionId) {
            this.$services.hsProducts.getForTreeSelect({
                language: window.currentOfficialLanguageInt,
                hsVersionCode: hsVersionId
            })
                .then((data) => {
                    const items = [];
                    data.items.forEach(function (t1) {
                        items.push({id: t1.id, code: t1.code, description: t1.description});
                        t1.children.forEach(function (t2) {
                            items.push({id: t2.id, code: t2.code, description: t2.description});
                            t2.children.forEach(function (t3) {
                                items.push({id: t3.id, code: t3.code, description: t3.description});
                                t3.children.forEach(function (t4) {
                                    items.push({id: t4.id, code: t4.code, description: t4.description});
                                    t4.children.forEach(function (t5) {
                                        items.push({id: t5.id, code: t5.code, description: t5.description});
                                    });
                                });
                            });
                        });
                    });
                    this.options = items;
                });
        },
    },
    template: `
      <div class="control-container">
        <div style="display: flex; align-items: center; gap: 2px">
            <span class="label on-border">
              {{ label }}
              <a v-if="showHelpIcon" :title="helpIconTitle"
                 style="text-decoration: none"
                 @click="$emit('show-help')"
                 href="javascript:void(0)">
                  <b-icon pack="far" icon="info-circle" size="is-small"></b-icon>
              </a>
            </span>
          <b-tooltip v-if="showDisclaimerIcon" class="search-product-free-text" style="margin-bottom: 3px" :label="disclaimerTooltip" type="is-primary is-light" position="is-right" size="is-large" multilined>
            <b-icon pack="far" icon="book-open" size="is-small"></b-icon>
          </b-tooltip>
        </div>
        <a ref="hsCodeAnchor" class="button control-collapse" @click="triggerSelector">
          <div contentEditable=true :data-text="placeholder" class="truncate-overflow" :title="names" style="max-width: 400px">{{ names }}</div>
          <b-icon icon="chevron-down" pack="fas" type="is-primary"></b-icon>
        </a>
        <div class="multi-select-control" v-show="showSelector" v-closable="{exclude: ['hsCodeAnchor'], handler: 'onFocusOut'}">
          <b-field label-position="on-border">
            <hs-products
                @on-data-change="onDataChange"
                ref="hsProductRef"
                :hs-version-code="hsVersionId"
                :label="label"
                :placeholder="placeholder"
                :language="language"
                :list.sync="options"
                :filtered-hs-codes.sync="computedValue">
            </hs-products>
          </b-field>
        </div>
      </div>
    `
});